import { inject, Injectable }                                                                          from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable }                                                                                  from 'rxjs';
import { map }                                                                                         from 'rxjs/operators';
import { SessionService }                                                                              from '../../../api/session/session.service';
import { InternalRoutes }                                                                              from '../../../shared/data/internal-routes';

@Injectable({
  providedIn: 'root'
})
export class CustomerLevelAccessGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private sessionService = inject(SessionService);


  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> {
    return this.userHasCustomerLevelAccess();
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> {
    return this.userHasCustomerLevelAccess();
  }

  private userHasCustomerLevelAccess(): Observable<boolean | UrlTree> {
    return this.sessionService.loadSession().pipe(map(
      data => (data.hasCustomerLevelAccess) ? true : this.router.parseUrl(InternalRoutes.ERROR)));
  }
}
